import React, { Fragment } from "react";
import Link from "next/link";
import { htmlParse } from "@unisearch/helpers";
import Image from "next/image";
import styles from "./find_university.module.scss";
import { useGetBestUniQuery } from "@redux/misc/miscApi/bestUniApi";

export const FindUniversity = ({ title, shortDescription, customClasses }) => {
  const { data } = useGetBestUniQuery();
  const universities = data?.data;

  return (
    <Fragment>
      {universities && universities?.length > 0 ? (
        <section
          className={`${styles.section_find_university} ${
            customClasses?.root ? customClasses.root : ""
          }`}
        >
          <div className="container">
            <div className={`${styles.title_wrapper}`}>
              <h2 className={`${styles.title} fw400`}>
                {title ? (
                  htmlParse(title)
                ) : (
                  <span>
                    Find the Best University for <br /> You with{" "}
                    <span className="mark">Unisearch</span>
                  </span>
                )}
              </h2>
              <p className={`${styles.sub_title} sub_title`}>
                {shortDescription ? (
                  shortDescription
                ) : (
                  <>
                    There’s a perfect university out there for every student.
                    And we’re here to help you find yours. UniSearch brings
                    together universities and institutions from major study
                    abroad destinations to a single place - right here!
                  </>
                )}
              </p>
            </div>
            <div className={styles.uni_logo_wrapper}>
              <ul>
                {universities?.map((item, i) => {
                  return (
                    <Fragment key={i}>
                      {item?.universityLogoSrc && (
                        <li>
                          <Link
                            href={`/study/${item?.countrySlug}/university/${item?.universitySlug}`}
                          >
                            <Image
                              src={item?.universityLogoSrc}
                              alt={item?.universityName}
                              width={132}
                              height={48}
                            />
                          </Link>
                        </li>
                      )}
                    </Fragment>
                  );
                })}
              </ul>
            </div>
          </div>
        </section>
      ) : (
        <></>
      )}
    </Fragment>
  );
};

export default FindUniversity;
